import { render, staticRenderFns } from "./DashboardPiutangCustomer.vue?vue&type=template&id=25524f0b&"
import script from "./DashboardPiutangCustomer.vue?vue&type=script&lang=js&"
export * from "./DashboardPiutangCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports